const formatPrice = (price) => {
	if (!price || isNaN(price)) return "0.00";
	return Number(price).toFixed(2);
};
export default formatPrice;
